
document.addEventListener("DOMContentLoaded", function () {

    window.switchTab = function(btn, tabId) {

        // remove active from buttons
        document.querySelectorAll(".product-detail-tabs-nav .tab-btn")
            .forEach(b => b.classList.remove("active"));

        // remove active from panels
        document.querySelectorAll(".product-detail-tab-panel")
            .forEach(p => p.classList.remove("active"));

        // activate clicked button
        btn.classList.add("active");

        // activate correct panel
        const panel = document.getElementById("tab-" + tabId);
        if (panel) {
            panel.classList.add("active");
        }
    };

});

  /* ── Accordion toggle ── */
        function toggleAcc(header) {
            const body = header.nextElementSibling;
            if (!body || !body.classList.contains("accordion-body")) {
                return;
            }
            // Close other accordions in sibling groups only (prevent accidental neighbours opening)
            const group = header.closest('.product-detail-specs-group');
            if (group) {
                const grid = group.parentElement; // .product-detail-specs-grid
                const groups = grid.querySelectorAll('.product-detail-specs-group');
                groups.forEach((g) => {
                    if (g === group) return;
                    const h = g.querySelector('.product-detail-specs-group-accordion-header');
                    const b = g.querySelector('.product-detail-specs-group-accordion-body');
                    if (h) h.classList.remove('open');
                    if (b) b.classList.remove('open');
                });
            }

            // Toggle clicked accordion
            const willOpen = !header.classList.contains('open');
            header.classList.toggle('open', willOpen);
            body.classList.toggle('open', willOpen);
        }

        /* ── FAQ toggle (single open) ── */
        function toggleFaq(q) {
            const item = q.closest(".faq-item");
            const grid = q.closest(".faq-grid");

            if (!item || !grid) return;

            const allItems = grid.querySelectorAll(".faq-item");

            // Check if current already open
            const isOpen = item.classList.contains("open");

            // Close all
            allItems.forEach((el) => el.classList.remove("open"));

            // Open clicked one
            if (!isOpen) {
                item.classList.add("open");
            }
        }